import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputBaseComponent } from 'src/app/_core';

@Component({
  standalone: true,
  selector: 'neopos-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [FormsModule, NgClass],
})
export class InputCheckboxComponent extends InputBaseComponent<string> {
  isExpanded = signal(false);

  @Input() name = '';
  @Input() additionalId = '';
  @Input() iconName = '';
  @Input() showLabel = true;
  @Input() showError = true;
  @Input() checked = false;
  @Input({ required: true }) inputId!: string;

  @Output() focus: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();

  onKeyDown(event: KeyboardEvent, inp: HTMLInputElement): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      inp.click();
    }
  }
}
